import type {Branded} from '@kapitalist/utils/Branded'
import {brand} from '@kapitalist/utils/Branded'

/** An ISO-8601 timestamp string (e.g. `new Date().toISOString()`). */
export type TISOTimestamp = Branded<string, typeof isoTimestampBrand>
export const mkISOTimestamp = (timestamp: string): TISOTimestamp =>
  brand<TISOTimestamp>(timestamp)
declare const isoTimestampBrand: unique symbol
